import { Component, Input, OnInit } from '@angular/core';
import { globalStyles, ThemeProviderProps, themes } from '@kite_aerolab/shared/themes';
import { toastListStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-theme-provider',
  template: '<div [ngClass]="themes"><ng-content></ng-content></div>',
})
export class ThemeProviderComponent implements OnInit, ThemeProviderProps {
  /**
   * Theme a aplicar
   */
  @Input() theme: ThemeProviderProps['theme'];
  /**
   * Brand del theme
   */
  @Input() brand: ThemeProviderProps['brand'];
  /**
   * Reset de CSS
   */
  @Input() resetCSS: ThemeProviderProps['resetCSS'];

  public get themes(): any {
    if (this.brand) {
      return [themes[this.brand][this.theme || 'default'].className];
    }
  }

  public get toastList(): string[] {
    return [toastListStyles().className];
  }

  ngOnInit(): void {
    if (this.resetCSS) globalStyles();
  }
}
